export const BASIC_OPACITY_ANIMATION = ({
    duration = 0.5,
    delay = 0,
}: {
    duration?: number
    delay?: number
    ease?: "easeIn" | "easeOut"
}) => ({
    initial: {
        opacity: 0,
        pointerEvents: "none",
    },
    animate: {
        opacity: 1,
        pointerEvents: "auto",
        transition: { duration, delay, ease: "easeOut" as const },
    },
    exit: {
        opacity: 0,
        pointerEvents: "none",
        transition: { duration, ease: "easeIn" as const },
    },
})
